import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import styles from './CommentBox.module.css';
import { getIconNameForFileExtension } from '../../../../HelperMethods/constants';
import { getFileExtension, getFileName } from '../../../../HelperMethods/UtilityFunctions';
import { useDownloadButtonClicked } from '../../../../HelperMethods/CommonHooks';

function convertDateStringToMMDDYYYYFormat(dateStr) {
  if (!dateStr) return '';
  return moment(dateStr).format('MM/DD/YYYY, hh:mm a');
}

function commentDescription(comment) {
  let commentText = comment.comment;
  if (!_.isEmpty(comment.users)) {
    Object.keys(comment.users).forEach((userId) => {
      const user = comment.users[userId];
      commentText = commentText.replace(user.displayString, `<span>${user.displayString}</span>`);
    });
  }
  if (!_.isEmpty(comment.assets)) {
    Object.keys(comment.assets).forEach((assetId) => {
      const asset = comment.assets[assetId];
      commentText = commentText.replace(asset.displayString, `<b>${asset.displayString}</b>`);
    });
  }
  return { __html: `<p>${commentText}</p>` };
}

export default function CommentBox({ comment, onUpdateButtonClicked }) {
  const loggedInUser = useSelector((state) => state.appReducer.loggedInUser);
  return (
    <div className={styles.commentBox}>
      <div className={styles.commentedByAndActionButtonContainer}>
        <div className={styles.commentedByAndDateContainer}>
          <div className={styles.commentedBy}>
            {comment.createdBy}: {loggedInUser.userName === comment.createdBy && <span>You</span>}
          </div>
          <div className={styles.commentDate}>{convertDateStringToMMDDYYYYFormat(comment.createdOn)}</div>
        </div>
        <div>
          {comment.createdBy === loggedInUser.userName && (
            <CommentActions
              onUpdateButtonClicked={() => {
                onUpdateButtonClicked(comment);
              }}
            />
          )}
        </div>
      </div>
      <div className={styles.commentText} dangerouslySetInnerHTML={commentDescription(comment)} />
      <CommentFileAttachments attachments={comment.attachments} />
    </div>
  );
}

function CommentActions({ onUpdateButtonClicked }) {
  const [expandActionButtons, setExpandActionButtons] = useState(false);
  return (
    <>
      {expandActionButtons && (
        <>
          <Button
            className={styles.actionButton}
            icon
            onClick={() => {
              setExpandActionButtons(false);
              onUpdateButtonClicked();
            }}
          >
            <Icon name="pencil square" />
          </Button>
          {/* <Button className={styles.actionButton} icon>
            <Icon name="trash alternate" />
          </Button> */}
        </>
      )}
      <Button
        style={{
          background: expandActionButtons ? 'black' : '#e0e1e2',
          color: expandActionButtons ? 'white' : 'rgba(0,0,0,.6)',
        }}
        className={styles.actionButton}
        icon
        onClick={() => setExpandActionButtons(!expandActionButtons)}
      >
        <Icon name={expandActionButtons ? 'close' : 'ellipsis horizontal'} />
      </Button>
    </>
  );
}

function CommentFileAttachments({ attachments }) {
  if (!attachments || !attachments.length) return null;
  return (
    <div className={styles.attachmentContainer}>
      {attachments.map((attachment) => (
        <div key={attachment.key} className={styles.attachmentBox}>
          <div className={styles.attachmentIcon}>
            <Icon name={getIconNameForFileExtension(getFileExtension(attachment.key))} />
          </div>
          <div className={styles.attachmentName}>{attachment.fileName || getFileName(attachment.key)}</div>
          <div className={styles.attachmentActionButtons}>
            <DownloadButton attachment={attachment} />
          </div>
        </div>
      ))}
    </div>
  );
}

function DownloadButton({ attachment }) {
  const onDownloadButtonClicked = useDownloadButtonClicked(attachment);
  return (
    <Button icon className={styles.actionButton} onClick={onDownloadButtonClicked}>
      <Icon name="download" />
    </Button>
  );
}
